<!-- Vue component -->
<template>
  <div class="container-autocomplete" :class="{'tooltip': tooltipEnabled, 'regFlow': regFlowLogin}">
    <div class="input-container" >
        <multi-select
        ref="myMultiselect"
        v-model="value"
        :options="options"
        :track-by="optionKey"
        :label="optionValue"
        :placeholder="placeHolder"
        :multiple="isMultiselect"
        :searchable="isAutoSuggest"
        :showNoResults="!isFreeType"
        :taggable="isFreeType"
        :allow-empty="false"
        :max-height="maxHeight"
        :disabled="disabledVal"
        deselectGroupLabel=""
        deselectLabel=""
        selectGroupLabel=""
        selectLabel=""
        selectedLabel=""
        tagPlaceholder=""
        openDirection="below"
        @tag="selectTypeahead"
        @update:modelValue="updateValue"
        @keyup.down="keyArrowDown"
		    @keyup.up="keyArrowUp"
        @open="autocompleteOpened"
        @close="autocompleteClosed"
        @blur="onBlur"
        >
        <template v-slot:singleLabel="props">
          <img class="option__image" v-if="props.option.img" :src="props.option.img" alt="icon">
          <span :class="{'option__title': props.option.img}">{{ props.option[optionValue] }}</span>
        </template>
        <template v-slot:option="props">
          <img class="option__image" v-if="props.option.img" :src="props.option.img" alt="icon">
          <span :class="{'option__title': props.option.img}">{{ props.option[optionValue] }}</span>
        </template>
        <template v-slot:noResult>
          <span class="noresult-autocomplete">No Result Found</span>
        </template>
        </multi-select>
        <div class="outer-tooltip-container" v-if="tooltipEnabled" v-tooltip="tooltipOptions">
          <span :class="tooltipOptions.iconClasses"></span>
        </div>
        <span class="input-placeholder" :class="[value ? regFlowLogin ? 'animate mt-m5-alt' : 'animate mt-m5' : '', regFlowLogin ? 'regFlow-placeholder' : '']">{{placeHolderValue}}</span>
    </div>
  </div>
</template>

<script setup>
import { ref, watch } from 'vue';
import VueMultiselect from 'vue-multiselect';

// Define component options
defineOptions({
  name: 'MaterialCustomDropDown',
  components: {
    'multi-select': VueMultiselect,
  }
});

// Define props
const props = defineProps({
  labelDisplayName: {
    type: String,
  },
  isMultiselect: {
    type: Boolean,
    default: false,
  },
  isoptionSelectOnClose: {
    type: Boolean,
    default: true,
    required: false,
  },
  isFreeType: {
    type: Boolean,
    default: false,
  },
  isAutoSuggest: {
    type: Boolean,
    default: false,
  },
  options: {
    type: Array,
    required: true,
  },
  optionKey: {
    type: String,
  },
  optionValue: {
    type: String,
  },
  placeHolder: {
    type: String,
    default: 'placeholder',
  },
  placeHolderValue: {
    type: String,
    required: true
  },
  isRequired: {
    type: Boolean,
    default: false,
    required: false,
  },
  initValue: {
    type: Object,
    required: false,
  },
  maxHeight: {
    required: false
  },
  disabledVal: {
    type: Boolean,
    required: false,
  },
  resetVal: {
    type: Boolean,
    required: false
  },
  regFlowLogin: Boolean,
  tooltipEnabled: {
    type: Boolean,
    default: false,
    required: false,
  },
  tooltipOptions: {
    type: Object,
    default: () => {
      return {
        placement: 'top',
        classes: [''],
        offset: 0,
        delay: {
          show: 600,
          hide: 500,
        },
        content: '',
      };
    },
  },
});

// Define emits
const emit = defineEmits(['change', 'update', 'select', 'blur']);

// Reactive data
const lastSelectedPointer = ref(0);
const value = ref(props.initValue ? props.initValue : '');
const myMultiselect = ref(null);
const userInput = ref('');
const usingArrows = ref(false);

// Methods
const selectTypeahead = (newLabel) => {
  const tag = {};
  tag[props.optionKey] = 0;
  tag[props.optionValue] = newLabel;
  props.options.push(tag);
  let val;
  if (props.isMultiselect) {
    if (Array.isArray(value.value)) {
      value.value.push(tag);
    } else {
      const tempArray = [];
      if (Object.keys(value.value).length !== 0) {
        tempArray.push(value.value);
      }
      tempArray.push(tag);
      val = tempArray;
    }
  } else {
    val = tag;
  }
  updateValue(val);
};

const updateValue = (val) => {
  emitChange(value.value, val);
  emit('update', val);
};

const selectValue = (val) => {
  emit('select', val);
};

const onBlur = (val) => {
  emit('blur', val);
};

const emitChange = (oldVal, newVal) => {
  if(newVal && oldVal !== newVal) {
    emit('change', newVal);
  }
};

const autocompleteOpened = (id) => {
  userInput.value = '';
  usingArrows.value = false;
  if (!props.isMultiselect) {
    myMultiselect.value.pointer = lastSelectedPointer.value;
  }
};

const autocompleteClosed = (closedValue, id) => {
  if(!props.isoptionSelectOnClose) {
    return;
  }
  if (userInput.value !== '' && !usingArrows.value) {
    addItems(userInput.value);
  }

  let targetItem = props.options[myMultiselect.value.pointer];
  if ( targetItem !== undefined 
    && !targetItem.$isDisabled && !targetItem.isSeperator) {
      lastSelectedPointer.value = myMultiselect.value.pointer;
    if (props.isMultiselect) {
      if (Array.isArray(value.value)) {
        value.value.push(targetItem);
      } else {
        const tempArray = [];
        if (Object.keys(value.value).length !== 0) {
          tempArray.push(value.value);
        }
        tempArray.push(targetItem);
        value.value = tempArray;
      }
     myMultiselect.value.pointer = 0; 
  }
  else{
    value.value = targetItem;
  }
    emitChange(closedValue, value.value);
    emit("update", value.value);
    usingArrows.value = false;
  }
};

const keyArrowUp = (e) => {
  usingArrows.value = true;
};

const keyArrowDown = (e) => {
  usingArrows.value = true;
};

const addItems = (inputValue) => {
  // This method was referenced but not defined in the original component
  // Adding a placeholder implementation
  console.log('addItems called with:', inputValue);
};

// Watchers
watch(() => props.resetVal, (newVal) => {
  if (newVal) {
    value.value = "";
    updateValue(value.value);
  }
});

watch(() => props.options, () => {
  if (value.value) {
    const newValue = props.options.filter(item => item[props.optionKey] === value.value[props.optionKey]);
    if (newValue && newValue.length) {
      value.value = newValue[0]
    }
  }
}, { deep: true });
</script>

<!-- Adding VueMultiselect CSS to the component. -->
<style src="vue-multiselect/dist/vue-multiselect.css"></style>
<!-- <style src="../../../node_modules/vue-multiselect/dist/vue-multiselect.min.css"></style> -->

<!-- Adding component specific style.-->
<style lang="stylus">
.container-autocomplete {
  text-align: left;
  width: 100%;
  padding-top: 5px;
  z-index 1;
  .option__image{
    width: 15px;
    vertical-align: middle !important;
  }
  .option__title { 
    font-size: 14px !important;
    margin-right: 4px;
    margin-left: 4px;
  }
  .label-autocomplete {
    margin-bottom: 5px;
    color: #39424D;
    &.required:before {
      content: "*";
      color: #CE2012;
      font-size: 16px;
    }
  }
  .animate{
    opacity: 1;
    font-size: 13px;
    transform: translateY(0) translateX(-10px);
    padding: 0 0 0 20px;
  }
  .mt-m5{
    margin-top: -5px;
    &-alt {
      margin-left: -4px;
      margin-top: -18px;
    }
  }
  .multiselect {
    cursor: pointer;
    font-size: 16px;
    background: #ffffff;
    color: #465363;
    font-family: inherit;
    .multiselect__select {
        &:before {
        color: #3a4145;
        border-color: #3a4145 transparent transparent;
      }
    }
    &:hover {
      background-color: white;
    }
    .multiselect__tags {
      border-color: transparent;
      border-bottom: 1px solid #dee2e6;
      border-radius: 0px;
      background: none;
      font-size: 16px;
      .multiselect__tags-wrap {
        display: block;
        .multiselect__tag {
          color: #FFF;
          background: #0FACF3;
          .multiselect__tag-icon {
            &:focus {
              &:after {
                color: #868894;
              }
            }
            &:hover {
              &:after {
                color: #868894;
              }
            }
            &:after {
              color: #FFF;
              font-size: 16px;
            }
          }
        }
      }
      .multiselect__spinner {
        background: #FAFBFC;
        &:after,
        &:before {
          border-color: #DEE2E6 transparent transparent;
        }
      }
      .multiselect__input {
        border-radius: 3px;
        font-size: 16px;
        &:-ms-input-placeholder,
        &::placeholder {
          color: #b9babd;
        }
        &:hover {
          border-color: #DEE2E6;
        }
        &:focus {
          border-color: #868894;
        }
      }
      .multiselect__placeholder {
        color: #b9babd;
        width: 100%;
        opacity: 0;
      }
      .multiselect__single {
        background: none;
        font-size: 1.25rem;
        padding: 8px 0px 3px 0px;
        margin-bottom: 0px;
        color: #868894;
        text-overflow: ellipsis;
        overflow : hidden;
        white-space: nowrap;
        &:hover {
          border-color: #DEE2E6;
        }
        &:focus {
          border-color: #868894;
        }
      }
      &:focus-within {
        border-color: #0FACF3;
      }
    }
    .multiselect__content-wrapper {
      .multiselect__content {
        z-index: 4;
      }
      z-index: 4;
      background: #FAFBFC;
      border: 1px solid #DEE2E6;
      .multiselect__content{
        .multiselect__option{
          .noresult-autocomplete {
            padding: 0px 12px 0px 12px;
          }
        }
      }
      .multiselect__element{
        .multiselect__option {
          padding: 0px 12px 0px 12px;
          min-height: 12px;
          line-height: 30px;
        }
        .multiselect__option--highlight {
          background: #0FACF3;
          &:after {
            background: #0FACF3;
          }
        }
        .multiselect__option--selected {
          background: #FAFBFC;
          color: #868894;
        }
        .multiselect__option--selected.multiselect__option--highlight {
          color: white;
          background: #0FACF3;
          &:after {
            background: #0FACF3;
          }
        }
        .multiselect__option--disabled {
          background: #FAFBFC !important;
          color: #868894 !important;
        }
      }
    }
  }
  .multiselect--disabled {
    background: #FAFBFC;
    .multiselect__current,
    .multiselect__select {
      background: #FAFBFC;
      color: #868894;
    }
  }
  .multiselect--above {
    .multiselect__content-wrapper {
      border: 1px solid #DEE2E6;
    }
  }
}
.tooltip {
  .multiselect__select {
    right: 18px;
    padding-right: 30px;
  }
  .multiselect--active {
    .multiselect__select {
        right: 32px;
      }
  }
}
.regFlow {
  padding-top: 0px;
  .multiselect * {
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    font-size: 14px;
    font-family: 'Lato', sans-serif;
    color: #3a4145;
  }
  .multiselect--active {
    z-index: auto;
  }
  .multiselect--active ~ .animate{
       color: #2E90FA;
    }
    .multiselect--active .multiselect__tags{
       border:1px solid #2E90FA !important;
    }
  .multiselect .multiselect__tags {
    height: 40px;
    border: 1px solid #d3d3d3;
    border-radius: 4px;
    padding: 0px 40px 0 8px;
    &:focus {
      border: 1px solid #2E90FA;
      border-radius: 4px;
    }
  }
  .multiselect .multiselect__tags .multiselect__single{
      padding: 8.5px 0px 3px 2px !important;
  }
  &-placeholder {
    max-width: calc(100% - 50px) !important;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    font-family: 'Lato', sans-serif;
    padding: 12px 0 15px 10px;
    color: #868894;
    font-size: 14px;
    &--before {
      padding: 15px 0 15px 10px;
    }
  }
  .animate{
    transform: translateY(12px) translateX(14px);
    width: auto;
    font-family: 'Lato', sans-serif;
    background-color: #fff;
    font-size: 11px;
    padding: 0px 2px 1px 2px !important;
    z-index: auto;
  }
  .outer-tooltip-container{
    position: absolute;
    right: 1px;
    top: 1px;
    background-color: #f7f7f7;
    width: 32px;
    height: 38px;
    text-align: center;
  }
}
div {
  min-width: 0;
}
</style>
